import { FeiertagEntry } from '@/domain/termine/features/Calendar/List/Feiertag/FeiertagEntry';
import { ListDayCell } from '@/domain/termine/features/Calendar/List/ListDayCell';
import { renderDayHeader } from '@/domain/termine/features/Calendar/List/ListDayHeader';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { Feiertag } from '@/domain/termine/shared/types/Feiertag';
import { Termin } from '@/domain/termine/shared/types/Termin';
import { Day } from '@/domain/termine/type';
import dayjs from 'dayjs';
import { useMemo } from 'react';

interface ListDayProps {
  day: Day;
  week: Day[];
  hasFeiertag: (day: Day, feiertag: Feiertag[]) => boolean;
  getTermineForDay: (day: Day) => Termin[];
  alleTermine: Termin[];
}

export function ListDay({
  day,
  week,
  hasFeiertag,
  getTermineForDay,
  alleTermine,
}: ListDayProps) {
  const { feiertage } = useCalendarContext();
  const today = dayjs().startOf('day').locale('de');

  const termineForDay = useMemo(
    () => getTermineForDay(day),
    [getTermineForDay, day],
  );
  const isToday = day.isSame(today, 'day');

  const isTodayInWeek = week.some((day) =>
    day.startOf('day').isSame(today, 'day'),
  );

  const isTodayTermin = alleTermine.some((termin) =>
    dayjs(termin.datum).startOf('day').isSame(today, 'day'),
  );
  const showHeader =
    hasFeiertag(day, feiertage) ||
    termineForDay.length > 0 ||
    (isToday && isTodayInWeek && !isTodayTermin);

  return (
    <div key={day.format('DD-MM-YYYY')}>
      {renderDayHeader(day, isToday, showHeader)}
      <FeiertagEntry day={day} />
      <ListDayCell
        day={day}
        termineForDay={termineForDay}
        isToday={isToday}
        hasFeiertag={hasFeiertag}
        isTodayInWeek={isTodayInWeek}
        isTodayTermin={isTodayTermin}
      />
    </div>
  );
}
